<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <div v-if="modal" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl sm:w-full overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline" style="max-height: 70vh;">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-md leading-6 font-medium text-gray-900" id="modal-headline" v-if="claim">
                SIGUIMIENTOS ({{ claim.code }})
              </h3>
              <div class="flex flex-col px-10 xl:px-0">
                <div class="flex flex-col px-10 xl:px-0 pt-2 pb-2">
                  <textarea rows="2" class="border" v-model="note"></textarea>
                  <p class="py-2 m2 sm:flex sm:flex-row-reverse">                   
                    <button 
                      v-if="note != ''"
                      :disabled="loading"
                      :class="[loading ? 'cursor-wait opacity-50' : '']"
                      @click="addNote"
                      class="inline-flex items-end bg-transparent hover:bg-green-500 text-xs text-green-700 font-semibold hover:text-white py-2 px-2 border border-green-500 hover:border-transparent rounded">
                      <svg
                        class="w-5 h-5 mr-2 -ml-1 text-white-500 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"
                        ></path>
                      </svg>
                      Agregar
                    </button>
                  </p>
                </div>
                <table class="min-w-full">
                    <thead>
                      <tr>
                        <th
                          class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-gray-500 uppercase border border-gray-200 bg-gray-50"
                        >Fecha/Hora</th>
                        <th
                          class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-gray-500 uppercase border border-gray-200 bg-gray-50"
                        ><CENTER>NOTA</CENTER></th>
                        <th
                          class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-gray-500 uppercase border border-gray-200 bg-gray-50"
                        >Usuario</th>
                        <th 
                          v-if="isSysa"
                          class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-gray-500 uppercase border border-gray-200 bg-gray-50">
                        </th>
                      </tr>
                    </thead>
                    <tbody class="bg-white">
                        <tr v-for="t in traces" :key="t.id">
                            <td
                              class="px-6 py-4 whitespace border-b border-gray-200"
                            >
                              <div class="text-sm text-center leading-5 text-gray-500">
                                {{ t.created_at | fechaHora }}
                              </div>
                            </td>
                            <td
                              class="px-6 py-4 whitespace border-b border-gray-200"
                            >
                              <div class="text-sm text-center leading-5 text-gray-500">
                                {{ t.text }}
                              </div>
                            </td>
                            <td
                              class="px-6 py-4 whitespace border-b border-gray-200"
                            >
                              <div class="text-sm text-center leading-5 text-gray-500">
                                {{ t.user }}
                              </div>
                            </td>
                            <td
                              v-if="isSysa"
                              class="px-6 py-4 whitespace border-b border-gray-200"
                            >
                              <div class="text-sm text-center leading-5 text-gray-500">
                                <svg
                                  @click="removeTrace(t)"
                                  class="w-4 h-4 mr-2 -ml-1 text-red-400 cursor-pointer"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M17.114,3.923h-4.589V2.427c0-0.252-0.207-0.459-0.46-0.459H7.935c-0.252,0-0.459,0.207-0.459,0.459v1.496h-4.59c-0.252,0-0.459,0.205-0.459,0.459c0,0.252,0.207,0.459,0.459,0.459h1.51v12.732c0,0.252,0.207,0.459,0.459,0.459h10.29c0.254,0,0.459-0.207,0.459-0.459V4.841h1.511c0.252,0,0.459-0.207,0.459-0.459C17.573,4.127,17.366,3.923,17.114,3.923M8.394,2.886h3.214v0.918H8.394V2.886z M14.686,17.114H5.314V4.841h9.372V17.114z M12.525,7.306v7.344c0,0.252-0.207,0.459-0.46,0.459s-0.458-0.207-0.458-0.459V7.306c0-0.254,0.205-0.459,0.458-0.459S12.525,7.051,12.525,7.306M8.394,7.306v7.344c0,0.252-0.207,0.459-0.459,0.459s-0.459-0.207-0.459-0.459V7.306c0-0.254,0.207-0.459,0.459-0.459S8.394,7.051,8.394,7.306">
                                  </path>
                                </svg>
                              </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="closeModal"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-grey-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-xs sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M3.24,7.51c-0.146,0.142-0.146,0.381,0,0.523l5.199,5.193c0.234,0.238,0.633,0.064,0.633-0.262v-2.634c0.105-0.007,0.212-0.011,0.321-0.011c2.373,0,4.302,1.91,4.302,4.258c0,0.957-0.33,1.809-1.008,2.602c-0.259,0.307,0.084,0.762,0.451,0.572c2.336-1.195,3.73-3.408,3.73-5.924c0-3.741-3.103-6.783-6.916-6.783c-0.307,0-0.615,0.028-0.881,0.063V2.575c0-0.327-0.398-0.5-0.633-0.261L3.24,7.51 M4.027,7.771l4.301-4.3v2.073c0,0.232,0.21,0.409,0.441,0.366c0.298-0.056,0.746-0.123,1.184-0.123c3.402,0,6.172,2.709,6.172,6.041c0,1.695-0.718,3.24-1.979,4.352c0.193-0.51,0.293-1.045,0.293-1.602c0-2.76-2.266-5-5.046-5c-0.256,0-0.528,0.018-0.747,0.05C8.465,9.653,8.328,9.81,8.328,9.995v2.074L4.027,7.771z">
                </path>
              </svg>
              Volver
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueAlertify from 'vue-alertify';

Vue.use(VueAlertify);

export default {
  props: {
      claim: {},
      modal: false
  },

  data() {
    return {
      loading: false,
      note: '',
      traces: [],
      isSysa: false
    }
  },

  mounted() {
    const user = JSON.parse(localStorage.getItem('user'))
    this.isSysa = (user.user.roles.indexOf("SYSA") !== -1)
  },

  watch: {
    modal (value) {
      if (value) {
        this.getTraces()
      }
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    async getTraces() {
      this.traces = await this.$http.get(`trace/claim/${this.claim.id}`)
    },
    async addNote() {
      try {
        this.loading = true
        const resp = await this.$http.post('/trace/create', {claim_id: this.claim.id, note: this.note})
        this.note = ''
        this.getTraces()
        this.$alertify.success('Nota agregada!') 
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$alertify.error('ERROR. No se ha podido agregar la nota!')
      } 
    },
    async removeTrace(trace) {
      this.$alertify.confirmWithTitle(
        'Eliminar Seguimiento',
        `¿Esta seguro que desea eliminar el siguimiento creado por ${trace.user}?`,
        async () => {
          try {
            await this.$http.delete(`/trace/${trace.id}/remove`)
            this.getTraces()
            this.$alertify.success('Seguimiento eliminado!') 
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido eliminar el seguimiento!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    }
  },
}
</script>

